import { createStore } from 'vuex'

declare let SessionStorage:any;
const USER = '_KSDM_ADMIN_USER_';
const EXAM = 'ADMIN_EXAM';

const store = createStore({
  state: {
    user: SessionStorage.get(USER) || {},
    exam: SessionStorage.get(EXAM) || {},
  },
  mutations: {
    setUser ( state, user ) {
      state.user = user
      SessionStorage.set(USER, user)
    },
    setExam (state, exam) {
      state.exam = exam
      SessionStorage.set(EXAM, exam)
    }
  },
  actions: {
  },
  modules: {
  }
})
export default store;
